import * as React from 'react';
import { Divider, Row, Col } from 'antd';

import { Title } from '../../../components/Layout/components';
import Form from '../../../components/Form';
import GeneralSettingsCol from './components/General';
import CountriesSettingsCol from './components/Countries';

interface IPaymentMethodDetailProps {
  domain: string;
  paymentMethod: GQL.IPaymentMethod;
  languages: Array<GQL.ILanguage>;
  onSave: (paymentMethod: GQL.IPaymentMethod) => void;
  onCancel: () => void;
}

interface IPaymentMethodDetailState {
  paymentMethod: GQL.IPaymentMethod;
  selectedCountryIds: Array<string>;
  currentLanguage: string;
}

export default class PaymentMethodDetail extends React.Component<IPaymentMethodDetailProps, IPaymentMethodDetailState> {

  public constructor(props: IPaymentMethodDetailProps) {
    super(props);

    this.state = {
      paymentMethod: props.paymentMethod,
      selectedCountryIds: props.paymentMethod && props.paymentMethod.countries
        ? props.paymentMethod.countries.map(c => c.id)
        : [],
      currentLanguage: props.languages.map(l => l.value)[0],
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { languages } = this.props;
    const { paymentMethod, currentLanguage } = this.state;

    return (
      <div>
        <Title
          languages={languages}
          currentLanguage={currentLanguage}
          onChange={(l: string) => { this.setState({ currentLanguage: l }); }}
        >
          {paymentMethod
            ? `Payment method ${paymentMethod.title ? `"${paymentMethod.title}"` : ''}`
            : `Payment methods`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row>
            <Col md={24} lg={11}>
              <GeneralSettingsCol
                paymentMethod={paymentMethod}
                currentLanguage={currentLanguage}
                onChange={this.onChange}
              />
            </Col>
            <Col lg={1} />
            <Col md={24} lg={11}>
              <CountriesSettingsCol
                domain={this.props.domain}
                paymentMethod={paymentMethod}
                selectedCountryIds={this.state.selectedCountryIds}
                currentLanguage={currentLanguage}
                onChange={this.onChange}
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);

    if (name === 'selectedCountryIds') {
      this.setState({
        selectedCountryIds: value,
      });
    } else {
      // vše ostatní
      const newValue = (language
        ? { [name]: { ...this.state.paymentMethod[name], [language]: inputValue } }
        : { [name]: inputValue });
      this.setState({
        paymentMethod: { ...this.state.paymentMethod, ...newValue }
      });
    }
  }

  private async save() {
    const paymentMethod = {
      ...this.state.paymentMethod,
      countryIds: this.state.selectedCountryIds,
    };
    this.props.onSave(paymentMethod);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/PaymentMethods/PaymentMethodDetail/PaymentMethodDetail.tsx